import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

export default function Description({ text, primaryColor }) {
  const [isReadMore, setIsReadMore] = useState(true);

  if (!text) return null;

  return (
    <div className="relative w-full" style={{ position: 'relative', width: '100%' }}>
      <div
        className={`prose max-w-none ${isReadMore ? 'line-clamp-2' : ''}`}
        style={
          isReadMore
            ? {
                maxWidth: '100%',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }
            : { maxWidth: '100%' }
        }
      >
        <ReactMarkdown
          components={{
            h1: ({ children }) => (
              <h1 className="text-2xl font-bold mb-4" style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1rem' }}>
                {children}
              </h1>
            ),
            h2: ({ children }) => (
              <h2 className="text-xl font-bold mb-3" style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '0.75rem' }}>
                {children}
              </h2>
            ),
            h3: ({ children }) => (
              <h3 className="text-lg font-bold mb-2" style={{ fontSize: '1.125rem', fontWeight: 700, marginBottom: '0.5rem' }}>
                {children}
              </h3>
            ),
            p: ({ children }) => (
              <p className="text-lg text-gray-600 mb-2 mt-1" style={{ fontSize: '1.125rem', color: '#4b5563', marginTop: '0.25rem', marginBottom: '0.5rem' }}>
                {children}
              </p>
            ),
            ul: ({ children }) => (
              <ul className="list-disc ml-6 mb-4" style={{ listStyleType: 'disc', marginLeft: '1.5rem', marginBottom: '1rem' }}>
                {children}
              </ul>
            ),
            ol: ({ children }) => (
              <ol className="list-decimal ml-6 mb-4" style={{ listStyleType: 'decimal', marginLeft: '1.5rem', marginBottom: '1rem' }}>
                {children}
              </ol>
            ),
            li: ({ children }) => (
              <li className="text-gray-600 mb-1" style={{ color: '#4b5563', marginBottom: '0.25rem' }}>
                {children}
              </li>
            ),
            a: ({ href, children }) => (
              <a
                href={href}
                className="text-blue-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2563eb', textDecoration: 'none' }}
              >
                {children}
              </a>
            ),
          }}
        >
          {text}
        </ReactMarkdown>
      </div>
      {text.length > 100 && (
        <button
          onClick={() => setIsReadMore(!isReadMore)}
          className="text-sm font-medium hover:underline mt-2"
          style={{ color: primaryColor, fontSize: '0.875rem', fontWeight: 500, marginTop: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
        >
          {isReadMore ? 'Read More' : 'Read Less'}
        </button>
      )}
    </div>
  );
}
